import { editorConventions, editorBundlesConfig } from './editor';
import { editorXBundlesConfig, editorXConventions } from './editorX';
import { dataBindingBundlesConfig, dataBindingConventions, } from './dataBinding';
import { documentManagementBundlesConfig, documentManagementConventions, } from './documentManagement';
import { corvidBundlesConfig, corvidConventions } from './corvid';
import { thunderboltPreviewBundlesConfig, thunderboltPreviewConventions, } from './thunderboltPreview';
import { siteAssetsBundlesConfig, siteAssetsConventions } from './siteAssets';
import { thunderboltConventions, thunderboltBundlesConfig, } from './thunderbolt';
export var hostsConventions = {
    corvid: corvidConventions,
    editor: editorConventions,
    editorX: editorXConventions,
    documentManagement: documentManagementConventions,
    thunderboltPreview: thunderboltPreviewConventions,
    siteAssets: siteAssetsConventions,
    dataBinding: dataBindingConventions,
    thunderbolt: thunderboltConventions,
};
export var hostsBundlesConfigs = {
    corvid: corvidBundlesConfig,
    editor: editorBundlesConfig,
    editorX: editorXBundlesConfig,
    documentManagement: documentManagementBundlesConfig,
    thunderboltPreview: thunderboltPreviewBundlesConfig,
    siteAssets: siteAssetsBundlesConfig,
    dataBinding: dataBindingBundlesConfig,
    thunderbolt: thunderboltBundlesConfig,
};
var stylableMetadataAsset = {
    pattern: /\.metadata\.json$/,
    type: 'stylable-metadata',
};
export var hostAssets = {
    thunderbolt: [stylableMetadataAsset],
    thunderboltPreview: [stylableMetadataAsset],
};
//# sourceMappingURL=index.js.map